module.exports = __webpack_public_path__ + "assets/-_1.c6a81ee5.svg";